import { TypedChangingEntityString } from '../../generated/api/kreditportalBackendAPI.schemas';
import { ValidationError } from './validation/validation.error';
import { UserValidator } from './validation/validation.user';

export class PartnerChangeRequest {

    constructor(
        public externePartnerId: string,
        public ordnungsbegriff: string,
        public vorname: TypedChangingEntityString,
        public name: TypedChangingEntityString,
        public adresszeile1: TypedChangingEntityString,
        public adresszeile2: TypedChangingEntityString,
        public adresszeile3: TypedChangingEntityString,
        public adresszeile4: TypedChangingEntityString,
        public email: TypedChangingEntityString,
        public telefon: TypedChangingEntityString,
        public texteingabe: string
    ) {
    }

    refreshChangedFlags() {
        this.vorname.changed = this.vorname.oldValue !== this.vorname.recentValue;
        this.name.changed = this.name.oldValue !== this.name.recentValue;
        this.adresszeile1.changed = this.adresszeile1.oldValue  !== this.adresszeile1.recentValue;
        this.adresszeile2.changed = this.adresszeile2.oldValue  !== this.adresszeile2.recentValue;
        this.adresszeile3.changed = this.adresszeile3.oldValue  !== this.adresszeile3.recentValue;
        this.adresszeile4.changed = this.adresszeile4.oldValue  !== this.adresszeile4.recentValue;
        this.email.changed = this.email.oldValue  !== this.email.recentValue;
        this.telefon.changed = this.telefon.oldValue  !== this.telefon.recentValue;
    }

    validate(): ValidationError[] {
        const result = [];

        if (this.email.recentValue && this.email.recentValue.length !== 0) {
            // FIXME Hier muss ich noch ran
            // if (!this.email.controlControlValues()) {
            //     result.push(new ValidationError(
            //         'email',
            //         'E-Mail-Adresse und E-Mail-Adresse-Wiederholung stimmen nicht &uuml;berein.',
            //     ));
            // }

            if (!UserValidator.validateEmail(this.email.recentValue)) {
                result.push(new ValidationError('email', 'Die eingegebene E-Mail-Adresse ist nicht g&uuml;ltig.'));
            }
        }

        return result.length === 0 ? null : result;
    }

}
